import { DialogContent, Stack, Typography } from "@mui/material";
import {
  DistaDialog,
  DistaDialogActions,
  DistaDialogHeader,
  DistaMarkdownViewer,
} from "@sista/dista-ui";
import { SistaId } from "@sista/library-stasi";
import { SistaChip } from "@sista/sista-chip";
import { useTranslation } from "react-i18next";

export type OrganizationRelationToOrganizationFoundedProps = {
  profileId: string;
  authToken: string;
  onSwitchProfile: (profileId: string) => void;
  onClose: () => void;
};

export const OrganizationRelationToOrganizationFounded = ({
  profileId,
  authToken,
  onSwitchProfile,
  onClose,
}: OrganizationRelationToOrganizationFoundedProps) => {
  const { t } = useTranslation("ucet");
  const primaryActionHandler = () => {
    onSwitchProfile(profileId);
  };

  return (
    <DistaDialog onClose={onClose} open={true}>
      <DistaDialogHeader
        onClose={onClose}
        title={t(
          "organization.register.dialog.relationToOrganizationFounded.title",
          "Nalezen profil s vazbou k organizaci",
        )}
      />
      <DialogContent>
        <Stack
          direction={"column"}
          spacing={2}
          alignItems={"center"}
          sx={{ my: 2 }}
        >
          <SistaChip
            urn={new SistaId("profiles", profileId).asUrn()}
            authToken={authToken}
          />
          <DistaMarkdownViewer
            value={t(
              "organization.register.dialog.relationToOrganizationFounded.content",
              "Byl nalezen profil, který má vazbu k organizaci, kterou se chystáte zaregistrovat. Pokud chcete registrovat organizaci pod tímto profilem, musíte změnit IČO/ DIČ v registračním formuláři.",
            )}
          />
        </Stack>
      </DialogContent>
      <DistaDialogActions
        primaryAction={{
          children: t(
            "organization.register.dialog.relationToOrganizationFounded.switchProfile",
            "Přepnout profil",
          ),
          onClick: primaryActionHandler,
        }}
      />
    </DistaDialog>
  );
};
